// extracted by mini-css-extract-plugin
export default {"productGallery":"xK-z","inQuickShop":"yK-z"};